module.exports = __webpack_public_path__ + "media/img/clients/client__bg-cca9cb978976ad7ce8f4de1976ac8d16.png";